import { authLinks, AuthRoutes } from '@ox-technologies/auth';

// authLinks.find can be undefined; assert-with-throw is the legit narrowing
// here (a missing link is a build/config error, not a runtime-recoverable
// state). Replaces the two duplicated `?.link as string` casts.
const getAuthLink = (route: AuthRoutes): string => {
  const link = authLinks.find((authLink) => authLink.route === route)?.link;
  if (!link) {
    throw new Error(`No auth link configured for route: ${route}`);
  }
  return link;
};

export const appRoutes = {
  home: '/',
  logIn: '/login',
  logOut: '/logout',
  loggedOut: '/logged-out',
  register: '/register',
  registerByEmailInvitation: '/register-by-email-invitation/$token/$userEmail',
  forgottenPassword: '/forgotten-password',
  changeForgottenPassword: '/forgotten-password/$token/$expirationTime',
  error: '/error',
  dashboard: '/dashboard',
  changePassword: getAuthLink(AuthRoutes.CHANGE_PASSWORD),
  profile: getAuthLink(AuthRoutes.MY_PROFILE),
  deviceCode: '/device',
} as const;

// Paths that require authentication. Used by useStoredPath to remember the
// intended destination around the OIDC login flow.
export const protectedPaths: string[] = [
  appRoutes.dashboard,
  appRoutes.changePassword,
  appRoutes.profile,
  appRoutes.deviceCode,
];

// Full TanStack route IDs — public routes gain the pathless `/public` layout
// prefix and protected routes the `/protected` prefix, so IDs differ from the
// URL paths in `appRoutes` above (used for navigation `to`). Use these for
// route-id-keyed hooks like `useParams({ from })`. Kept here rather than
// imported from `router.tsx` so page components don't create an import cycle
// back into the router (router.tsx imports the pages).
export const routeIds = {
  registerByEmailInvitation:
    '/public/register-by-email-invitation/$token/$userEmail',
  changeForgottenPassword: '/public/forgotten-password/$token/$expirationTime',
} as const;
